export default {
  SHOW_ALL_GUIDES_PAGE: 'home-dashboard:all-guides-page:show',
};
